/**
 * Utility functions for loom kit handling
 * Handles reading loom products from metafield and preparing for bundle
 */

/**
 * Gets all loom kit products to add to bundle
 * Reads from embedded JSON script tag [data-loom-products]
 * @returns {Array|null} Array of loom products in bundle format or null
 */
function getLoomKitProducts() {
  const loomScript = document.querySelector('[data-loom-products]');

  if (!loomScript) {
    return null;
  }

  let loomProducts = [];
  try {
    loomProducts = JSON.parse(loomScript.textContent);
  } catch (e) {
    console.error('Error parsing loom products JSON:', e);
    return null;
  }

  if (!loomProducts || !Array.isArray(loomProducts) || loomProducts.length === 0) {
    console.warn('Loom products array is empty or invalid');
    return null;
  }

  return loomProducts
    .map((product) => {
      const variant = product.variants?.[0];

      if (!variant) {
        console.warn(`Product ${product.id} has no variants, skipping`);
        return null;
      }

      return {
        quantity: 1,
        name: product.title || '',
        sku: variant.sku || '',
        id: String(product.id || ''),
      };
    })
    .filter(Boolean);
}

/**
 * Checks if current product has a loom kit
 * @returns {boolean} True if loom kit container exists
 */
function hasLoomKit() {
  const loomContainer = document.querySelector('[data-loom-kit-container]');
  return loomContainer && loomContainer.dataset.hasLoom === 'true';
}

/**
 * Checks if any loom kit product is sold out
 * @returns {boolean} True if any loom product is unavailable
 */
function isLoomKitSoldOut() {
  const loomContainer = document.querySelector('[data-loom-kit-container]');
  if (!loomContainer) {
    return false;
  }

  const hasLoom = loomContainer.dataset.hasLoom === 'true';
  const isSoldOut = loomContainer.dataset.loomSoldOut === 'true';

  return hasLoom && isSoldOut;
}

function handleLoomSoldOut() {
  const loomContainer = document.querySelector('[data-loom-kit-container]');
  if (!loomContainer) return;

  const hasLoom = loomContainer.dataset.hasLoom === 'true';
  const isLoomSoldOut = loomContainer.dataset.loomSoldOut === 'true';

  if (hasLoom && isLoomSoldOut) {
    console.log('Loom kit is sold out');
    const submitButton = document.querySelector('.product-form__submit');
    const stickyButton = document.querySelector('#ProductSubmitButton-Sticky');
    const variantIdInputs = document.querySelectorAll('.product-variant-id');
    const soldOutText = window?.variantStrings?.soldOut || 'Sold out';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.setAttribute('aria-label', soldOutText);
      const buttonTexts = submitButton.querySelectorAll('span');
      buttonTexts.forEach((span) => {
        span.textContent = soldOutText;
      });
    }

    if (stickyButton) {
      stickyButton.disabled = true;
      stickyButton.setAttribute('aria-disabled', 'true');
      stickyButton.setAttribute('aria-label', soldOutText);
      const stickyButtonText = stickyButton.querySelector('span');
      if (stickyButtonText) {
        stickyButtonText.textContent = soldOutText;
      }
    }

    variantIdInputs.forEach((input) => {
      input.disabled = true;
      input.setAttribute('aria-disabled', 'true');
    });
  }
}

document.addEventListener('DOMContentLoaded', handleLoomSoldOut);
